import Select from "../../../../components/select/Select";
import { SettingsRow } from "../settings-row/SettingsRow";

const WEIGHT_UNITS = ["kg", "lbs"];

export const WeightSelector = ({
  unit = "kg",
  onUnitChange,
  disabled = false,
}) => {
  const handleChange = event => {
    const newUnit = event.target.value;
    if (newUnit && newUnit !== unit && onUnitChange) {
      onUnitChange(newUnit);
    }
  };

  return (
    <SettingsRow
      labelKey="288"
      className="settings-weight-selector"
      id="weight-selector"
    >
      <Select
        items={WEIGHT_UNITS}
        onChange={handleChange}
        selectedItem={unit}
        id="weight-selector-select"
        disable={disabled}
      />
    </SettingsRow>
  );
};
